import { Injectable, model, signal } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { ToastService } from '../services/toast-service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private toastService: ToastService
  ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean
  {
    const requiredPermission = route.data['permission'] as string;

    if (!this.tokenService.isAuthenticated()) {
      this.toastService.showErrorToast("Session Expired");
      this.router.navigateByUrl("/login");
      return false;
    }

    if (requiredPermission) {
      const permissions = this.tokenService.getPermissions();

      if (!permissions.includes(requiredPermission)) {
        this.toastService.showErrorToast("Access Denied");
        this.router.navigate(['/dashboard']);
        return false;
      }
    }

    return true;
  }

}
